import { connect } from 'react-redux';
import {
  getCustomers,
  getFranchise,
  getLeads,
  addLeads,
  getGeocodeAddress,
  resetGeocodeAddress,
  checkZipCode
} from '../../../../Action';
import CustomerList from "../Component/CustomerList";

const mapStateToProps = (state) => {
  const {
    loading,
    franchise: franchiseData,
    error: settingError} = state.Settings;

  const {
    customerList,
    error: residentialError
  } = state.CustomerList;

  const {Lead, GoogleApi, ZipcodeCheck} = state;

  return {
    customerList,
    loading,
    franchiseData,
    settingError,
    residentialError,
    Lead,
    GoogleApi,
    ZipcodeCheck
  }
}

const actionCreators = {
  getCustomers,
  getLeads,
  addLeads,
  getFranchise,
  getGeocodeAddress,
  resetGeocodeAddress,
  checkZipCode
}
export default (connect(mapStateToProps, actionCreators)(CustomerList));